import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import './CreateOrderModal.css';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import appURL from '../../../appURL.json';
import { getAll } from '../../../localDB';
import OpalSearchInput from '../../OpalSearchInput/OpalSearchInput';
import { accountMapping } from '../../../visualizations/visualizations';
import { Input, Label } from 'reactstrap';

const CreateOrderModal = ({ show, onHide, isCreating, onProceed }) => {

    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [remarks, setRemarks] = useState('');

    const [errors, setErrors] = useState({});

    const handleProceed = () => {
        const newErrors = {};
        if (!selectedAccount) newErrors.selectedAccount = 'Account is required.';
        if (!deliveryAddress) newErrors.deliveryAddress = 'Delivery Address is required.';

        setErrors(newErrors);

        // If there are any errors, don't proceed
        if (Object.keys(newErrors).length > 0) return;

        const payload = {
            SessionID: null,
            AccountID: selectedAccount.ID,
            DeliveryAddress: deliveryAddress,
            Remarks: remarks
        };

        onProceed?.(payload);
    };

    const resetForm = () => {
        setSelectedAccount(null);
        setDeliveryAddress('');
        setRemarks('');
        setErrors({});
    };

    const fetchAccount = async () => {
        try {
            const acc = await getAll("customer");
            const accFilter = acc.filter(a =>
                a.Type === accountMapping.Customer || a.Type === accountMapping.Doctor
            );

            setAccounts(accFilter);
        } catch {
            return
        }
    }

    useEffect(() => {
        resetForm();
        fetchAccount();
    }, [show])

    useEffect(() => {
        if (selectedAccount) {
            setDeliveryAddress(selectedAccount.AddressDetail)
        }
    }, [selectedAccount])

    return (
        <Modal
            className='create-order-modal'
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header>Create Order</Modal.Header>

            <Modal.Body>
                <Label>Account <span className="text-danger">*</span></Label>
                <OpalSearchInput
                    selectedItem={selectedAccount}
                    onSelectedItem={setSelectedAccount}
                    items={accounts}
                />
                {errors.selectedAccount && (
                    <div className="text-danger small mt-1">{errors.selectedAccount}</div>
                )}

                <Label className="mt-3">Delivery Address <span className="text-danger">*</span></Label>
                <Input
                    type='textarea'
                    className="py-1 flex-grow-1"
                    style={{ resize: 'none', minHeight: '3rem' }}
                    value={deliveryAddress}
                    onChange={e => setDeliveryAddress(e.target.value)}
                />
                {errors.deliveryAddress && (
                    <div className="text-danger small mt-1">{errors.deliveryAddress}</div>
                )}

                <Label className="mt-3">Remarks</Label>
                <Input
                    type='textarea'
                    className="py-1 flex-grow-1"
                    style={{ resize: 'none', minHeight: '3rem' }}
                    value={remarks}
                    onChange={e => setRemarks(e.target.value)}
                />
            </Modal.Body>


            <Modal.Footer className="justify-content-end">
                <Button className='btn-proceed d-flex align-items-center' disabled={isCreating} onClick={handleProceed}>
                    {isCreating && (
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#1D5D9B" />
                    )}
                    <span className="text-nowrap">Create</span>
                </Button>

                <Button className="btn-cancel d-flex" disabled={isCreating} onClick={onHide}>
                    <span className="text-nowrap">Cancel</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateOrderModal;
